import { ServiceRequestInterceptor } from 'nanium/interfaces/serviceRequestInterceptor';
import { ServiceRequestBase } from '../../../server/services/serviceRequestBase';
import { Session } from './session';
import { AccountsCreateRequest } from '../../../server/services/accounts/create.contract';
import { Router } from './router';
import { AppConfig } from './config';

export class ClientRequestInterceptor implements ServiceRequestInterceptor<any> {
  async execute(request: ServiceRequestBase<any, any>): Promise<ServiceRequestBase<any, any>> {
    if (request instanceof AccountsCreateRequest) {
      return request;
    }
    if (AppConfig.isTestSystem() && !Session.testSystemToken) {
      Router.push('/');
      return undefined;
    }
    // if (!Session.token && !request.head?.token && !(request.head?.email && request.head?.password)) {
    //   Router.push('/login/')
    //   return undefined;
    // }
    request.head ??= {};
    if (!request.head.email && !request.head.password) {
      request.head.token = Session.token;
    }
    if (AppConfig.isTestSystem() && Session.testSystemToken) {
      request.head.token = (Session.testSystemToken ?? '') + (Session.token ?? '');
    }
    request.head.language = navigator.language ?? navigator['userLanguage'];
    request.head.timezone = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone;
  }
}
